import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('logo-list', {
  onLoad() {
    this.thisSlider = document.querySelector('#logo-list__slider--' + this.id);

    // Reduce slide count by one to align with the 0 positioned slide
    this.logoIndicatorControllers = this.container.querySelector(
      '.controls-container--logo-list'
    );

    if (this.thisSlider) {
      const previousButtonLogos = this.logoIndicatorControllers.querySelector(
        '.btn--control__prev'
      );

      const nextButtonLogos = this.logoIndicatorControllers.querySelector(
        '.btn--control__next'
      );
      var logoSlider = new Flickity(this.thisSlider, {
        freeScroll: false,
        autoplay: false,
        contain: false,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'center',
        watchCSS: true,
        wrapAround: false,
        groupCells: true,
        on: {
          ready: function() {
            if (!nextButtonLogos) {
              return;
            }
            const unselectedSlide = this.thisSlider.querySelector(
              '.logo-block:not(.is-selected'
            );
            if (unselectedSlide) {
              nextButtonLogos.disabled = false;
            }
          }.bind(this),
        },
      });

      previousButtonLogos.addEventListener('click', function() {
        logoSlider.previous();
      });

      nextButtonLogos.addEventListener('click', function() {
        logoSlider.next();
      });

      logoSlider.on(
        'change',
        function() {
          const firstSlideUnselected = this.thisSlider.querySelector(
            '.logo-block:first-child:not(.is-selected'
          );
          const lastSlideUnselected = this.thisSlider.querySelector(
            '.logo-block:last-child:not(.is-selected'
          );
          if (firstSlideUnselected) {
            previousButtonLogos.disabled = false;
          } else {
            previousButtonLogos.disabled = true;
          }
          if (lastSlideUnselected) {
            nextButtonLogos.disabled = false;
          } else {
            nextButtonLogos.disabled = true;
          }
        }.bind(this)
      );
    }
  },
});
